import React from "react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <div className="flex flex-col items-center justify-center h-screen bg-[#860d26] text-white text-center px-4">
            <h1 className="text-8xl font-bold mb-6">404</h1>
            <h2 className="text-3xl font-semibold mb-8">PAGE NOT FOUND</h2>
            <p className="text-2xl mb-6 font-light max-w-2xl">
                <span className="font-semibold">Oops!</span> This page doesn’t
                exist.
            </p>
            <p className="text-lg max-w-2xl mb-10">
                The page you’re looking for might have been moved, deleted, or
                never existed.
                <br />
                Check the URL and try again, or use the button below to get back
                on track.
            </p>
            <button
                onClick={() => {
                    const user = JSON.parse(localStorage.getItem("user"));
                    navigate(user?.id ? "/dashboard" : "/");
                }}
                className="bg-white text-[#00264d] font-semibold px-8 py-3 text-lg rounded-full shadow hover:bg-gray-200 transition"
            >
                HOME
            </button>
        </div>
    );
};

export default NotFound;
